import {cloneDeep, pick} from 'lodash'
import InfoForm from './form/info.js'
import SitesForm from './form/sites.js'
import IntegrationsForm from './form/integrations.js'
import template from './_form.pug'

const Fields = [
  InfoForm.options.fields,
  SitesForm.options.fields,
  IntegrationsForm.options.fields
].flat()

export default Vue.extend({
  template: template(),
  components: {
    InfoForm,
    SitesForm,
    IntegrationsForm
  },
  props: {
    initData: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    saveButtonText: {
      type: String,
      default: () => Vue.i18n.t('general.save')
    }
  },
  data() {
    return {
      data: {},
      infoData: {},
      infoErrors: {},
      sitesData: {},
      sitesErrors: [],
      integrationsData: {},
      integrationsErrors: {},
      removeAvatar: false,
      whitelist: ['jpg', 'png', 'jpeg']
    }
  },
  watch: {
    initData: {
      immediate: true,
      handler() {
        this.initializeData()
      }
    },

    errors: {
      deep: true,
      immediate: true,
      handler() {
        this.infoErrors = pick(this.errors, InfoForm.options.fields)
        this.sitesErrors = pick(this.errors, SitesForm.options.fields)
        this.integrationsErrors = pick(this.errors, IntegrationsForm.options.fields)
      }
    }
  },
  methods: {
    initializeData() {
      this.infoData = cloneDeep(InfoForm.options.defaultValues())
      this.sitesData = cloneDeep(SitesForm.options.defaultValues())
      this.integrationsData = cloneDeep(IntegrationsForm.options.defaultValues())
      const data = {...this.infoData, ...this.sitesData, ...this.integrationsData}

      Fields.forEach(key => {
        data[key] = this.initData[key] || data[key]
      })

      this.data = data
      this.infoData = pick(data, InfoForm.options.fields)
      this.sitesData = pick(data, SitesForm.options.fields)
      this.integrationsData = pick(data, IntegrationsForm.options.fields)
    },

    t(key, options = {}) {
      return this.$t(`customers.form.${key}`, options)
    },

    submit() {
      this.data = {...this.infoData, ...this.sitesData, ...this.integrationsData}
      this.$emit('submit', this.data)
    },

    cancel() {
      this.$router.push({name: 'customers-index'})
    }
  }
})
